import { buildGlobalReferenceContext } from '../../context/buildGlobalReferenceContext.mjs';

const DROPDOWN_NAME = "Dropdown";
const DROPDOWN_CONTENT_NAME = "DropdownContent";
const [DropdownProvider, useDropdownContext] = buildGlobalReferenceContext(DROPDOWN_NAME);

export { DROPDOWN_CONTENT_NAME, DROPDOWN_NAME, DropdownProvider, useDropdownContext };
//# sourceMappingURL=context.mjs.map
